import {getProgressBarColor} from '../utils';
import styles from './styles.module.scss';

type HorizontalBarSizes = 'small' | 'medium' | 'large' | 'x-large' | 'xx-large';

type HorizontalBarVariants =
  | 'normal'
  | 'gradient'
  | 'gradient2'
  | 'v2gradient'
  | 'v2normal';

interface ElementProps {
  percentage: number;
  size?: HorizontalBarSizes;
  wrapperBackgroundColor?: string;
  progressBackgroundColor?: string;
  containerClassName?: string;
  progressBarClassName?: string;
  variant?: HorizontalBarVariants;
}

const HorizontalProgressBar = ({
  percentage,
  size,
  wrapperBackgroundColor,
  progressBackgroundColor,
  containerClassName,
  progressBarClassName,
  variant = 'normal',
}: ElementProps) => {
  let containerClass = `${styles.container} ${styles[variant]} `;

  if (size === 'xx-large') {
    containerClass += styles.xxLarge;
  } else if (size === 'x-large') {
    containerClass += styles.xLarge;
  } else if (size === 'large') {
    containerClass += styles.large;
  } else if (size === 'medium') {
    containerClass += styles.medium;
  } else {
    containerClass += styles.small;
  }

  const getWrapperBackgroundColor = () => {
    if (wrapperBackgroundColor) return wrapperBackgroundColor;

    if (variant === 'v2normal') {
      return '#FFFFFF1A';
    }

    return '#E8EAF5';
  };

  const getProgressBackgroundColor = () => {
    if (progressBackgroundColor) return progressBackgroundColor;

    if (variant === 'gradient' || variant === 'gradient2') {
      return 'var(--theme-primary-gradient, linear-gradient(107deg, #3ad0f8 0.53%, #2961f6 95.01%))';
    }

    if (variant === 'v2gradient') {
      return '#09e998';
    }

    if (variant === 'v2normal') {
      return '#FFFFFFCC';
    }

    return getProgressBarColor(percentage);
  };

  return (
    <div
      className={containerClassName || containerClass}
      style={{
        backgroundColor: getWrapperBackgroundColor(),
      }}
    >
      <div
        className={progressBarClassName || styles.progress}
        style={{
          background: getProgressBackgroundColor(),
          width: `${percentage}%`,
        }}
      />
    </div>
  );
};

export default HorizontalProgressBar;
